import { render, staticRenderFns } from "./ord_details.vue?vue&type=template&id=75f849bc&scoped=true"
import script from "./ord_details.vue?vue&type=script&lang=js"
export * from "./ord_details.vue?vue&type=script&lang=js"
import style0 from "./ord_details.vue?vue&type=style&index=0&id=75f849bc&prod&lang=css"
import style1 from "./ord_details.vue?vue&type=style&index=1&id=75f849bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f849bc",
  null
  
)

export default component.exports